import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import OrganisationIndexMapper from "../service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";

export default class GetOrganisationIndexesForCaseLawDocumentInteractor {
  private resource: GetResourceEntriesInteractor<IOrganisationIndex>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      ``,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper,
      {
        params: { caseLawDocumentId }
      }
    );
  }
}
